import Faq from '../modules/faq.js'

new Faq()